import useI18n from '@/mixins/useI18n';

const { locale } = useI18n();

const useCurrency = () => {
  const format = (value: string | number, minDigits = 2, maxDigits = 2) => {
    const numberFormat = new Intl.NumberFormat(locale.value, {
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits
    });

    return numberFormat.format(+value);
  };

  return { format };
};

export default useCurrency;
